import { Loader2Icon } from 'lucide-react';
import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

/**
 * The pre-shell screen: configuration errors, session bootstrap and the auth
 * callback. Deliberately independent of the app shell, because the shell needs
 * an identity and these screens run before there is one.
 */
export function FullPageMessage({
  title,
  detail,
  tone = 'neutral',
  busy = false,
  children,
}: {
  title: string;
  detail?: ReactNode;
  tone?: 'neutral' | 'destructive';
  busy?: boolean;
  children?: ReactNode;
}) {
  return (
    <main className="flex min-h-full items-center justify-center bg-background px-6 py-16">
      <div className="zs-dark-surface w-full max-w-md rounded-[40px] p-10 space-y-4 text-center">
        <div className="flex items-center justify-center gap-2">
          {busy ? (
            <Loader2Icon className="size-4 animate-spin text-muted-foreground" aria-hidden />
          ) : null}
          <h1
            className={cn(
              'text-2xl tracking-tight font-medium',
              tone === 'destructive' && 'text-destructive',
            )}
          >
            {title}
          </h1>
        </div>
        {detail ? <p className="text-sm text-muted-foreground">{detail}</p> : null}
        {children ? <div className="flex justify-center pt-1">{children}</div> : null}
      </div>
    </main>
  );
}
